import { render } from "./dealdetail.vue?vue&type=template&id=3863d4ff&scoped=true"
import script from "./dealdetail.vue?vue&type=script&lang=js"
export * from "./dealdetail.vue?vue&type=script&lang=js"

import "./dealdetail.vue?vue&type=style&index=0&id=3863d4ff&scoped=true&lang=css"
import "./dealdetail.vue?vue&type=style&index=1&id=3863d4ff&lang=css"

import exportComponent from "/Users/jx/project/wld/nongxin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3863d4ff"]])

export default __exports__